<template>
    <div class="index">
        <div class="main_center_carousel">
            <a-carousel dot-position="left" autoplay :autoplaySpeed="3000" arrows v-if="bannerList.length>1">
                <img v-for="(item,index) in bannerList" :key="index" :src="item.image" alt="" style="height:100%;">
            </a-carousel>
            <img v-if="bannerList.length==1" :src="bannerList[0].image" alt="" style="height:100%;width: 100%;">
        </div>
        <!-- 新闻中心 -->
        <div class="enterpiseDynamice main_center_box" v-if="newsInfo">
            <img  class="main_center_img" :src="newsInfo.image" alt="">
            <div class="posi_box">
                <div class="titleStyle">
                    <span class="titleFont">
                        <span>{{newsInfo.title}}</span>
                        <span class="enFont">{{newsInfo.englishTitle}}</span>
                    </span>
                </div>
                <div class="enterpiseDynamiceConent">
                    <div
                        class="enterpiseDynamiceList"
                        v-for="(item, idx) in newsInfo.cmsArticleList"
                        :key="idx"
                        @click="gotoRouteEnter(item.link)"
                    >
                        <img :src="item.image" class="enterpiseDynamiceListImg" />
                        <div class="enterpiseDynamiceListContent">
                            <div class="enterpiseDynamiceListContentTitle">
                                {{ item.title }}
                            </div>
                            <div>
                                <img src="@/assets/index/news_dot.png" alt=""><span class="rang">{{item.publishTime}}</span>
                            </div>
                            <div class="enterpiseDynamiceListContentContent">
                                {{ item.description }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 公益项目 -->
        <div class="wisdomLogistics main_center_box" v-if="projectInfo">
            <img :src="projectInfo.image" alt="" class="main_center_img">
            <div class="posi_box">
                
                <div class="main_center_img" style="position: relative;">
                <img
                    :src="wisdomLogisticsItemUrl"
                    class="wisdomRightTop"
                />
                <div class="titleStyle">
                        <span class="titleFont">
                            <span>{{projectInfo.title}}</span>
                            <span class="enFont">{{projectInfo.englishTitle}}</span>
                        </span>
                    </div>
                <div class="wisdomContentStyle">
                    <div class="wisdomLeft">
                        <div class="wisdomLeftTop">
                            <div
                                v-for="(item, idx) in projectList"
                                :key="idx"
                                class="wisdomLogisticsLeftItem"
                                @mouseenter="addwisdomLogisticsLeftItemStyle(idx)"
                            >
                                {{ item.title }}
                            </div>
                        </div>
                        <div class="wisdomLeftMid">
                            {{ wisdomLogisticsListContent }}
                        </div>
                        <div class="knowMore" @click="gotoRouteEnter(wisdomLogisticsLink)">
                            了解更多 <a-icon type="double-right" style="font-size: 18px;" />
                        </div>
                    </div>
                    <div class="wisdomRight">
                    </div>
                </div>
            </div>
            </div> 
        </div> 
        <!-- 基本信息 -->
        <div class="companyProfile main_center_box" v-if="basicInfo">
            <img src="@/assets/index/jibenxinxi.png" alt="" class="main_center_img">
            <img src="@/assets/index/jibenxinxi_top.png" alt="" class=" topimg">
            <div class="companyProfile_box">
                <div class="companyProfileLeft">
                    <div class="titleStyle" style="padding-bottom: 50px;">
                        <span class="titleFont">
                            <span>{{basicInfo.title}}</span>
                            <span class="enFont">{{basicInfo.englishTitle}}</span>
                        </span>
                    </div>
                    <div class="centerStyle">
                        <!-- <div class="conentStyle">
                            {{ basicInfo.cmsArticleList[0].description }}
                        </div> -->

                        <div class="conentStyle" v-html="basicInfo.cmsArticleList[0].remarks"></div>
                    </div>
                    <!-- <div class="knowMore" @click="gotoRouteEnter(basicInfo.cmsArticleList[0].link)">
                        了解更多 <a-icon type="double-right" style="font-size: 18px;" />
                    </div> -->
                </div>
                <div class="companyProfileRight">
                    <a-row :gutter="[3,3]" class="block_box">
                        <a-col 
                        v-for="(item,index) in basicList" 
                        :key="index"
                        :span="8" 
                        :offset="index==2||index==5?8:0"
                        >
                        <div class="card" @click="gotoRouteEnter(item.link)">
                            <img class="font" :src="item.image"  alt="">
                            <img class="back" :src="item.subImage"  alt="">
                        </div>
                        </a-col>
                    </a-row>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import $ from "jquery";
import { getAction } from "@/api/services";
export default {
    name: "Index",
    data() {
        return {
            bannerList:[],
            projectInfo:null,
            projectList:[],
            basicInfo:null,
            basicList:[],
            newsInfo:null,
            homeApiUrl1:"/jhwlweb/gwweb/cmsArticleCategory/queryArtListCmsArticleCategoryByCode",
            homeApiUrl2:"/jhwlweb/gwweb/cmsArticleCategory/queryArtListByCategoryCode",
            companyProfileUrl: "/jhwlweb/gwweb/cmsBaseinfo/queryById",
            wisdomLogisticsUrl:
                "/jhwlweb/gwweb/cmsArticleCategory/queryIndexZhwllist",
            wisdomLogisticsList: [],
            wisdomLogisticsListContent: "",
            wisdomLogisticsItemUrl: "",
            wisdomLogisticsLink:"",
            enterpiseDynamiceUrl:
                "/jhwlweb/gwweb/cmsArticleCategory/queryIndexArtList",
            enterpiseDynamiceList: [],
            enterpiseDynamiceConentShow: true,
            conentStyleShow: true,
            wisdomLogisticsListContentShow: true,
        };
    },
    created() {
        this.getBanner();
        this.getNews();
        this.getProject();
        this.getBasic();
    },
    mounted() {
        $(window).on("scroll", this.handScroll);
    },
    destroyed() {
        $(window).off("scroll", this.handScroll);
    },
    methods: {
        handScroll() {
            let boxTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            // 新闻中心
            let enterpiseDynamiceConentTop =
                $(".enterpiseDynamice").offset().top -
                $(".enterpiseDynamice").height() + 180;
            if (
                boxTop > enterpiseDynamiceConentTop &&
                this.enterpiseDynamiceConentShow
            ) {
                let targetEnterpiseDynamiceConentEle = document.querySelector(
                    ".enterpiseDynamiceConent"
                );
                targetEnterpiseDynamiceConentEle.style.animation =
                    "topMove 0.7s linear";
                targetEnterpiseDynamiceConentEle.style.opacity = 1;
                this.enterpiseDynamiceConentShow = false;
            }
            // 公益项目
            let wisdomLogisticsTop =
                 $(".wisdomLogistics").offset().top-$(".wisdomLogistics").height() + 150;
            if (boxTop > wisdomLogisticsTop && this.wisdomLogisticsListContentShow) {
                let wisdomStyleEle =
                    document.querySelector(".wisdomRightTop");
                wisdomStyleEle.style.animation = "rightMove 0.7s linear";
                wisdomStyleEle.style.opacity = 1;
                setTimeout(() => {
                    let wisdomStyleEleKnowMoreEle = document.querySelector(".wisdomLogistics").querySelector(".knowMore");
                    wisdomStyleEleKnowMoreEle.style.animation = "show 0.7s linear";
                    wisdomStyleEleKnowMoreEle.style.opacity = 1;
                }, 700);
                this.wisdomLogisticsListContentShow = false;
            }
            // 基本信息
            let centerStyleTop =
                 $(".companyProfile").offset().top-$(".companyProfile").height() + 500;
            if (boxTop > centerStyleTop && this.conentStyleShow) {
                let targetCenterStyleEle =
                    document.querySelector(".centerStyle");
                targetCenterStyleEle.style.animation = "topMove 0.7s linear";
                targetCenterStyleEle.style.opacity = 1;
                setTimeout(() => {
                    let targetKnowMoreEle = document.querySelector(".companyProfile").querySelector(".knowMore");
                    targetKnowMoreEle.style.animation = "show 0.7s linear";
                    targetKnowMoreEle.style.opacity = 1;
                }, 700);
                this.conentStyleShow = false;
            }
        },
        gotoRouteEnter(url) {
            // window.location.href=url;
            window.open(url);
            return;
        },
        // banner
        
        getBanner() {
            let that = this;
            getAction(that.homeApiUrl2, {
                code: 1,
            }).then((res) => {
                if (res.code == 200 && res.success) {
                    that.bannerList = res.result;
                }
            });
        },
        getNews(){
            let that = this;
            getAction(that.homeApiUrl1, {
                code: 4,
            }).then((res) => {
                if (res.code == 200 && res.success) {
                   that.newsInfo = res.result[0];
                }
            });
        },
        getProject() {
            let that = this;
            getAction(that.homeApiUrl1, {
                code: 2,
            }).then((res) => {
                if (res.code == 200 && res.success) {
                    var data=res.result[0];
                    that.projectInfo = data;
                    that.projectList = data.cmsArticleList;
                    that.wisdomLogisticsListContent =
                        that.projectList[0].description;
                    that.wisdomLogisticsItemUrl = that.projectList[0].image;
                    that.wisdomLogisticsLink = that.projectList[0].link;
                    that.$nextTick(() => {
                        $(".wisdomLogisticsLeftItem").removeClass("current");
                        $(".wisdomLogisticsLeftItem").eq(0).addClass("current");
                    });
                }
            });
        },
        getBasic() {
            let that = this;
            getAction(that.homeApiUrl1, {
                code: 3,
            }).then((res) => {
                if (res.code == 200 && res.success) {
                    that.basicInfo = res.result[0];
                    that.basicList = res.result[0].cmsArticleList.splice(1,res.result[0].cmsArticleList.length-1);
                }
            });
        },
        addwisdomLogisticsLeftItemStyle(item) {
            $(".wisdomLogisticsLeftItem").removeClass("current");
            $(".wisdomLogisticsLeftItem").eq(item).addClass("current");
            this.wisdomLogisticsListContent =
                this.projectList[item].description;
            this.wisdomLogisticsItemUrl = this.projectList[item].image;
            this.wisdomLogisticsLink = this.projectList[item].link;
        },
        gotoRoute(item) {
            let that = this;
            switch (item.menuCategory) {
                case 20:
                    that.$router.push({
                        path: "/projectServices/buildingMaterialsLogisticsService",
                    });
                    break;
                case 310:
                    that.$router.push({
                        path: "/projectServices/internationalFreightForwarder",
                    });
                    break;
                case 40:
                    that.$router.push({
                        path: "/projectServices/commodityLogisticsServices",
                    });
                    break;
                case 50:
                    that.$router.push({
                        path: "/projectServices/businessLogisticsService",
                    });
                    break;
                case 60:
                    that.$router.push({
                        path: "/projectServices/aftermarketService",
                    });
                    break;
            }
        },
    },
};
</script>
<style lang="less">
@keyframes topMove {
    0% {
        margin-top: 300px;
        opacity: 0;
    }
    100% {
        margin-top: 0;
        opacity: 1;
    }
}
@keyframes rightMove {
    0% {
        margin-right: -300px;
        opacity: 0;
    }
    100% {
        margin-right: 0;
        opacity: 1;
    }
}
@keyframes show {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.rang{
    font-size: 16px;
    padding-left: 10px;
    vertical-align: middle;
}
.corporateCultureFlexRight {
    .ant-carousel .slick-dots {
        width: auto;
    }
    .ant-carousel .slick-dots li button {
        opacity: 1;
    }
    .ant-carousel .slick-dots li.slick-active button {
        background-color: #2DC986;
    }
}

.ant-carousel .slick-prev{
        right: 58px;
        left: initial;
        top: initial;
        bottom: 142px;
        z-index: 1;
        height: 50px;
        width: 50px;
        background: url("../assets/index/slick_prev.png") no-repeat;
        background-size: 100% 100%;
}
.ant-carousel .slick-next{
        right: 58px;
        bottom: 80px;
        top: initial;
        z-index: 1;
        height: 50px;
        width: 50px;
        background: url("../assets/index/slick_next.png") no-repeat;
        background-size: 100% 100%;
}
.ant-carousel .slick-prev:hover,
 .ant-carousel .slick-prev:focus{
    background: url("../assets/index/slick_prev.png") no-repeat;
    background-size: 100% 100%;
 }
 .ant-carousel .slick-next:hover, 
  .ant-carousel .slick-next:focus{
    background: url("../assets/index/slick_next.png") no-repeat;
    background-size: 100% 100%;
}
.ant-carousel .slick-dots li button{
    width: 12px; 
    height: 12px; 
    border-radius: 50%; 
}
.ant-carousel-vertical .slick-dots li.slick-active button{
    width: 12px; 
    height: 12px; 
    border-radius: 50%; 
}
.main_center_carousel{
    max-width: 1920px;
    width: 100%;
    margin: 0 auto;
}
</style>
<style lang="less" scoped>
.beyondOne {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
.knowMore {
    opacity: 0;
    width: 168px;
    height: 53px;
    text-align: center;
    border: 2px solid #2dc885;
    cursor: pointer;
    font-size: 24px;
    font-weight: normal;
    color: #2dc885;
    line-height: 48px;
    font-family: '阿里巴巴普惠体';
    &:hover{
        background: #2dc885;
        color: #ffffff;
    }
}
.typeArea {
    max-width: 1300px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    max-width: 1300px;
    margin: 0 auto;
    width: 100%;
    padding-bottom: 94px;
    padding-top: 140px;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 36px;
        letter-spacing: 2px;
        color: #2DC986;
        border-bottom: 2px solid;
        padding-bottom: 18px;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #2DC986;
        }
    }
    .enFont {
        font-size: 34px;
        font-family: fangsong;
        font-weight: 600;
        color: #FFFFFF;
        padding-left: 20px;
    }
}
.index {
    .companyProfile {
        // height: 969px;
        // width: 1920px;
        // background: url("../assets/index/jibenxinxi.png") no-repeat;
        // background-size: 100% 100%;
        position: relative;
        .topimg{
            position: absolute;
            top: 172px;
            left: -310px;
        }
        .companyProfile_box{
            position: absolute;
            top: 172px;
            left: 0;
            display: flex;
            justify-content: space-between;
            width: 100%;
            .companyProfileRight{
                width: 630px;
                margin-right: -63px;
                .block_box{
                    img{
                        width: 100%;
                        cursor: pointer;
                    }
                }
                .card{
                    position: relative;
                    width: 208px;
                    height: 208px;
                }
                .font,.back{
                    position: absolute;
                    left: 0;
                    top: 0;
                    transition: all .5s;
                    // backface-visibility: hidden;
                }
                .font{
                    // transform: rotateX(0deg);
                    display: block;
                }
                .back{
                    // transform: rotateX(180deg);
                    display: none;
                }
                .card:hover .font{
                    // transform: rotateX(180deg);
                    // backface-visibility: visible;
                    display: none;
                }
                .card:hover .back{
                    // transform: rotateX(0deg);
                    // backface-visibility: visible;
                    display: block;
                }
            }
        }
        .titleFont{
            border-bottom: 2px solid #fff;
            .enFont {
                color: #d9d9d9;
            }
        }

        .companyProfileLeft{

        }
        .centerStyle {
            opacity: 0;
            .typeArea();
            .conentStyle {
                /* margin: 0 auto 45px; */
                /* text-align: justify; */
                max-width: 584px;
                /* font-size: 16px; */
                /* letter-spacing: 1px; */
                color: #fff;
                /* letter-spacing: 1.4px; */
                /* line-height: 32px; */
            }
        }
        .knowMore {


        }
    }
    .wisdomLogistics {
        position: relative;
        // background: url("../assets/index/index_computer.png") no-repeat;
        // background-size: 100% 100%;
        // width: 1920px;
        // height: 969px;
        .titleStyle {
            .titleFont {
                // color: #ffffff;
            }
                .enFont {
                    color: #B8B8B8;
                }
        }
        .wisdomRightTop {
            position: absolute;
            right: 0;
            top: 0;
            opacity: 0;
        }
        .wisdomContentStyle {
            .typeArea();
            display: flex;
            position: relative;
            .wisdomLeft {
                width: 35%;
                .wisdomLeftTop {
                    display: flex;
                    // justify-content: space-between;
                    font-size: 28px;
                    // font-family: "优设标题黑";
                    font-weight: 600;
                    color: #999999;
                    .wisdomLogisticsLeftItem {
                        cursor: pointer;
                        margin-right: 34px;
                        // border-bottom: 7px solid transparent;
                    }
                    .current {
                        // border-bottom: 7px solid white;
                        color: #333333;
                    }
                }
                .wisdomLeftMid {
                    font-size: 16px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 28px;
                    margin-bottom: 120px;
                    margin-top: 40px;
                    min-height: 75px;
                }
            }
            .wisdomRight {
                width: 50%;
                position: relative;
                .wisdomRightBom {
                    position: absolute;
                    top: 30px;
                    right: 30px;
                    z-index: 0;
                }
            }
        }
    }
    .posi_box{
        position: absolute;
        top: 0;
        width: 100%;
        left: 0;
    }
    .enterpiseDynamice {
        margin-top: -4px;
        position: relative;
        .enterpiseDynamiceConent {
            // opacity: 0;
            .typeArea();
            display: flex;
            justify-content: space-between;
            .enterpiseDynamiceList {
                // margin: 0 20px;
                // flex: 1;
                cursor: pointer;
                width: 400px;
                // box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
                .enterpiseDynamiceListImg {
                    width: 400px;
                    height: 265px;
                }
                .enterpiseDynamiceListContent {
                    // background-color: #fbfbfb;
                    color: #ffffff;
                    padding: 20px;
                    height: calc(100% - 300px);
                    .enterpiseDynamiceListContentTitle {
                        font-family: "黑体";
                        font-size: 18px;
                        padding-bottom: 10px;
                    }
                    .enterpiseDynamiceListContentContent {
                        margin: 40px 0 0;
                        font-size: 16px;
                        line-height: 1.8;
                        .beyondOne();
                        -webkit-line-clamp: 3;
                    }
                }
            }
            .enterpiseDynamiceList:hover {
                .enterpiseDynamiceListContent {
                    transition: all 0.3s ease-in;
                    background-color: rgba(171,152,127,0.8);
                    .enterpiseDynamiceListContentTitle {
                        color: white;
                    }
                    .enterpiseDynamiceListContentContent {
                        color: white;
                    }
                }
            }
        }
    }
}
</style>
